import { useContext } from "react";

import { UPSAPIContext, UPSContext } from "@app/provider";

export interface RequiredUpsSession {
  upsAccessToken: string;
  upsPatientUid: string;
  paymentRequestId: string;
}

/**
 * Returns UPS session values as non-nullable. Must be used inside a
 * `<RequireUpsSession>` boundary, which guarantees these values exist.
 * Throws if any required field is missing so misuse fails loudly in dev
 * instead of silently producing `undefined`s downstream.
 */
const useRequiredUpsSession = (): RequiredUpsSession => {
  const { upsAccessToken, upsPatientUid } = useContext(UPSContext);
  const {
    upsApiProviderState: { guestValidationData },
  } = useContext(UPSAPIContext);

  const paymentRequestId = guestValidationData?.paymentRequestId;

  if (!upsAccessToken || !upsPatientUid || !paymentRequestId) {
    throw new Error(
      "useRequiredUpsSession must be used inside a <RequireUpsSession> guard: " +
        "upsAccessToken, upsPatientUid and guestValidationData.paymentRequestId are required."
    );
  }

  return { upsAccessToken, upsPatientUid, paymentRequestId };
};

export default useRequiredUpsSession;
